module.exports = __webpack_public_path__ + "img/212-6ef0dc.png";